export const randomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(random(min, max));
};

export const random = (min = 0, max = 1) => Math.random() * (max - min) + min;



// WEBPACK FOOTER //
// ./src/helpers/random.js